<template lang="pug">
  .constructor-new-db
    v-card-title
      h3 Создание
    v-card-text
      v-form(ref="form", @submit.prevent="createNewDB", v-model="valid")
        v-layout(row justify-center)
          div
            v-radio-group(v-model="radioGroup1" row)
              v-radio(label="База данных" value="Database" color="primary")
              v-radio(label="Отдельная база данных" value="SingleDatabase" color="primary")
              v-radio(label="Классификатор" value="Classifier" color="primary")
              v-radio(label="Справочник" value="Catalog" color="primary")
        v-layout(row justify-center v-if="visibleRadioGroup2").mb-4
          div
            v-radio-group(v-model="radioGroup2" row)
              v-radio(label="Из классификатора" value="fromClassifier" color="primary")
              v-radio(label="Самостоятельный" value="independent" color="primary")
        v-layout(justify-center v-if="visibleFieldsGroup")
          v-flex(xs12 md10 xl8)
            v-select(solo, flat,
            :items="classifierList",
            item-text="name",
            item-value="id",
            label="Выберете Классификатор",
            v-model="item.classifierId")
        v-layout(justify-center v-if="visibleFieldsGroup")
          v-flex(xs12 md10 xl8)
            v-textarea(solo, flat, label="Введите запрос", v-model="item.classifierQuery")
        v-layout(row justify-center).my-4
          v-flex(xs12 md10 xl8)
            v-text-field(
            ref="name",
            flat
            solo,
            :error-messages="error",
            :rules="[v => !!v || 'Необходимо ввести название']",
            label="Введите название"
            v-model="item.name"
            type="text")
        v-layout(row justify-center).mb-4
          v-btn(large @click.prevent="cancel") Отмена
          v-btn(
            large
            color="primary",
            :loading="loading",
            :disabled="!valid",
            type="submit") Создать
</template>

<script>
import { mapState } from 'vuex'
import urls from '../../urls'
import axios from 'axios'
export default {
  name: 'NewDB',
  data() {
    return {
      item: {
        name: '',
        formType: 'Database',
        classifierId: '',
        classifierQuery: ''
      },
      valid: false,
      error: '',
      radioGroup1: 'Database',
      radioGroup2: 'independent',
      visibleRadioGroup2: false,
      visibleFieldsGroup: false,
      isDisabled: true,
      classifierList: [],
      fetchError: ''
    }
  },
  mounted() {
    this.$refs.name.$refs.input.focus()
  },
  watch: {
    radioGroup1(val) {
      this.item.formType = val
      if (val === 'Catalog') {
        this.visibleRadioGroup2 = true
      } else {
        this.visibleRadioGroup2 = false
        this.visibleFieldsGroup = false
        this.radioGroup2 = 'independent'
        this.item.classifierId = ''
        this.item.classifierQuery = ''
      }
    },
    radioGroup2(val) {
      if (val === 'fromClassifier') {
        this.visibleFieldsGroup = true
        this.getClassifierList()
      } else {
        this.visibleFieldsGroup = false
        this.item.classifierId = ''
        this.item.classifierQuery = ''
      }
    },
    'item.name': {
      deep: true,
      handler() {
        this.$store.state.dbConstructor.errors.newDbError = null
        this.error = ''
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.dbConstructor.loading.newDdBtn
    })
  },
  methods: {
    getClassifierList() {
      axios({
        method: 'GET',
        url: urls.GET_CLASSIFIER_LIST_URL
      })
        .then(response => {
          this.classifierList = response.data.result
        })
        .catch(error => {
          this.fetchError = error
        })
    },
    cancel() {
      this.$router.push({ path: '/main/constructor/list' })
      this.$refs.form.reset()
    },
    createNewDB() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('CREATE_NEW_DB', this.item).then(() => {
          this.error = this.$store.state.constructor.errors.newDbError
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Constructor/NewDB.vue